import { ComponentRef, ComponentPropsWithoutRef, Ref } from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import { cn } from '../../lib/utils'

type ProgressProps = ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    ref?: Ref<ComponentRef<typeof ProgressPrimitive.Root>>
}

function Progress({ className, value, ref, ...props }: ProgressProps) {
    return (
        <ProgressPrimitive.Root
            ref={ref}
            className={cn('relative h-4 w-full overflow-hidden rounded-full bg-secondary', className)}
            {...props}
        >
            <ProgressPrimitive.Indicator
                className="h-full w-full flex-1 bg-peach-gradient transition-all ease-in-out duration-700"
                style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
            />
        </ProgressPrimitive.Root>
    )
}

export { Progress }
